/* eslint-disable yola/react/require-default-props */
import React from 'react';
import Icon from '../../icon';
const CustomOption = ({ label, glyph }) => (
  <div className="ws-ui-icon-select__option">
    {glyph ? <Icon glyph={glyph} type="inherit" /> : null}
    <span className="ws-ui-icon-select__label">{label}</span>
  </div>
);

export default CustomOption;
